import './validation.js';
import './jquery.validate.extension.recaptchasolved.js';

(function ($) {
    if ($('.js-propertylisting-contact-form').length) {
        $('.js-propertylisting-contact-form').submit(function (e) {
            console.log('submit propoerty listing contact')
            e.preventDefault();
            let $form = $(this);
            if ($form.valid()) {
                $form.find("input[type='submit']").prop("disabled", true).css("cursor", "wait");
                $.ajax({
                    method: $form.attr("method"),
                    url: $form.attr("action"),
                    data: $form.serialize(),
                    success: function (data) {
                        $form.parent().html(data);
                        console.log('success')
                    },
                    error: function (data) {
                        console.log('err');
                        console.log(data);
                        $form.find("input[type='submit']").prop("disabled", false).css("cursor", "");
                    },
                    dataType: "html"
                });
            }
        });
    }

})(jQuery);
